import _mergeJSXProps from 'babel-helper-vue-jsx-merge-props';
import _defineProperty from 'babel-runtime/helpers/defineProperty';
import _extends from 'babel-runtime/helpers/extends';
import PropTypes from '../_util/vue-types';
import BaseMixin from '../_util/BaseMixin';
import CascaderProps from '../cascader/CascaderPropTypes';
import classNames from 'classnames';

var MenuItem = {
  mixins: [BaseMixin],
  props: _extends({}, CascaderProps, {
    activeValue: PropTypes.array.def([]),
    treeNodes: PropTypes.array,
    deep: PropTypes.number,
    maxDeep: PropTypes.number,
    columnHeight: PropTypes.number,
    isHeader: PropTypes.bool,
    prefixCls: PropTypes.string.def('rc-cascader-menu'),
    expandTrigger: PropTypes.string.def('click'),
    defaultFieldNames: PropTypes.object,
    visible: PropTypes.bool.def(false),
    dropdownMenuColumnStyle: PropTypes.object,
    menuStyle: PropTypes.object,
    menuColumnStyle: PropTypes.array,
    level: PropTypes.number.def(0),
    expandIcon: PropTypes.any,
    loadingIcon: PropTypes.any,
    checkedKeys: PropTypes.array.def([]),
    halfCheckedKeys: PropTypes.array.def([]),
    selectorValueList: PropTypes.array.def([]),
    fastFinderOption: PropTypes.array
  }),
  inject: {
    Cascader: { 'default': function _default() {
        return {};
      } },
    localeData: { 'default': function _default() {
        return {};
      } }
  },
  data: function data() {
    return {
      currentLetter: undefined
    };
  },

  methods: {
    getMenuItem: function getMenuItem(option, level) {
      var h = this.$createElement;
      var props = this.$props;
      var children = option.children;

      var menuItemProps = {
        props: _extends({}, props, {
          treeNodes: children,
          level: level
        })
      };
      return h(MenuItem, menuItemProps);
    },
    getOption: function getOption(option, menuLevel) {
      var _this = this;

      var h = this.$createElement;
      var _$props = this.$props,
          prefixCls = _$props.prefixCls,
          labelRender = _$props.labelRender,
          multiple = _$props.multiple,
          showGroup = _$props.showGroup,
          deep = _$props.deep,
          isHeader = _$props.isHeader,
          unrelated = _$props.unrelated,
          menuColumnStyle = _$props.menuColumnStyle,
          selectorValueList = _$props.selectorValueList,
          max = _$props.max,
          min = _$props.min,
          validatorFn = _$props.validatorFn,
          checkedKeys = _$props.checkedKeys,
          halfCheckedKeys = _$props.halfCheckedKeys,
          leafsPerColumn = _$props.leafsPerColumn;
      var defaultValidatorFn = this.Cascader.defaultValidatorFn;
      var key = option.key,
          children = option.children;

      var isLeaf = !children || children.length === 0;
      var checked = checkedKeys.indexOf(key) > -1;
      var indeterminate = halfCheckedKeys.indexOf(key) > -1;
      var validator = validatorFn || defaultValidatorFn;

      var onSelect = function onSelect(e) {
        e.stopPropagation();
        if (!isLeaf && !unrelated) return;
        _this.Cascader.onMenuSelect(option, menuLevel, e);
      };

      var onCheck = function onCheck(e) {
        e.stopPropagation();
        var isCheck = !checked;
        if (validator && (max > 0 || min > 0) && !validator({
          selectedOptions: selectorValueList,
          checked: isCheck,
          max: max,
          min: min
        })) {
          return;
        }
        _this.Cascader.onMenuCheck(option, isCheck, e);
      };
      var optionStyle = menuColumnStyle[menuLevel];
      if (showGroup && menuLevel === 0 || menuLevel === deep - 1 && !isHeader && leafsPerColumn === 0) {
        optionStyle = {};
      }
      if (menuLevel === deep - 1 && !isHeader && leafsPerColumn > 0) {
        var leafsWidth = menuColumnStyle[menuLevel].width.replace('px', '') / leafsPerColumn;
        optionStyle = { width: leafsWidth + 'px' };
      }
      if (menuLevel < deep - 1 && showGroup) {
        optionStyle.top = '32px';
      }

      var value = option.value,
          label = option.label;

      var expandProps = {
        attrs: {
          role: 'menuitem',
          label: label,
          value: value
        },
        on: {
          click: function click(e) {
            multiple ? onCheck(e) : onSelect(e);
          },
          // dblclick: onItemDoubleClick,
          mousedown: function mousedown(e) {
            return e.preventDefault();
          }
        },
        style: optionStyle,
        key: Array.isArray(value) ? value.join('__ways__') : value
      };

      var menuItemCls = prefixCls + '-' + (isHeader ? 'name' : 'menu') + '-item';
      var selected = this.isActiveOption(option, menuLevel);
      if (selected) {
        // menuItemCls += ` ${prefixCls}-menu-item-active`;
        expandProps.ref = this.getMenuItemRef(menuLevel);
      }
      if (option.disabled) {
        menuItemCls += ' ' + prefixCls + '-menu-item-disabled';
      }

      expandProps.attrs.title = label;
      expandProps['class'] = menuItemCls;

      var Checkbox = this.getCheckbox(option, { checked: checked, indeterminate: indeterminate, onCheck: onCheck });
      if (isHeader) {
        Checkbox = null;
      }
      var Radio = this.getRadio(option, { selected: selected, onSelect: onSelect });
      if (isHeader || !isLeaf && !unrelated) {
        Radio = null;
      }
      var Label = labelRender ? labelRender(h, {
        option: option,
        index: menuLevel,
        isHeader: isHeader
      }) : h('label', { attr: { label: label } }, label);

      if (multiple) {
        return h(
          'div',
          expandProps,
          [value !== undefined && h(Checkbox), Label]
        );
      } else {
        return h(
          'div',
          expandProps,
          [value !== undefined && h(Radio), Label]
        );
      }
    },
    getCheckbox: function getCheckbox(_, _ref) {
      var _classNames;

      var checked = _ref.checked,
          indeterminate = _ref.indeterminate;
      var h = this.$createElement;
      var prefixCls = this.$props.prefixCls;


      var checkboxProps = {
        attrs: {
          'class': classNames((_classNames = {}, _defineProperty(_classNames, prefixCls + '-checkbox', true), _defineProperty(_classNames, prefixCls + '-checkbox-checked', checked), _defineProperty(_classNames, prefixCls + '-checkbox-indeterminate', indeterminate), _classNames))
        }
        // on: {
        //   click: onCheck,
        // },
      };
      var Checkbox = {
        render: function render() {
          var h = arguments[0];

          return (
            /* 2022/1/24 替换checkbox样式提高性能 */
            h('span', checkboxProps)
          );
        }
      };
      return Checkbox;
    },
    getRadio: function getRadio(_, _ref2) {
      var _classNames2;

      var selected = _ref2.selected,
          onSelect = _ref2.onSelect;
      var h = this.$createElement;
      var prefixCls = this.$props.prefixCls;


      var radioProps = {
        attrs: {
          'class': classNames((_classNames2 = {}, _defineProperty(_classNames2, prefixCls + '-radio', true), _defineProperty(_classNames2, prefixCls + '-radio-checked', selected), _classNames2))
        },
        on: {
          click: onSelect
        }
      };
      var Radio = {
        render: function render() {
          var h = arguments[0];

          return (
            /* 2022/1/24 替换radio样式提高性能 */
            h('span', radioProps)
          );
        }
      };
      return Radio;
    },
    isActiveOption: function isActiveOption(option, menuLevel) {
      var _activeValue = this.activeValue,
          activeValue = _activeValue === undefined ? [] : _activeValue;

      return '' + activeValue[menuLevel] === '' + option.value && menuLevel === activeValue.length - 1;
    },
    getMenuItemRef: function getMenuItemRef(index) {
      return 'menuItems_' + index;
    },
    handleChange: function handleChange(value) {
      this.currentLetter = value;
      this.__emit('change', value);
    }
  },
  render: function render() {
    var _this2 = this;

    var h = arguments[0];
    var props = this.$props;
    var prefixCls = props.prefixCls,
        dropdownMenuColumnStyle = props.dropdownMenuColumnStyle,
        menuColumnStyle = props.menuColumnStyle,
        leafsPerColumn = props.leafsPerColumn,
        level = props.level,
        deep = props.deep,
        width = props.width,
        columnHeight = props.columnHeight,
        isHeader = props.isHeader,
        treeNodes = props.treeNodes,
        fastFinder = props.fastFinder,
        fastFinderPos = props.fastFinderPos,
        fastFinderOption = props.fastFinderOption,
        showGroup = props.showGroup;
    var currentLetter = this.$data.currentLetter;
    // 如果展示列数小于数据维度

    var isColumnStack = Array.isArray(width) && deep - (showGroup ? 1 : 0) - width.length > 0 && // 数据维度大于指定列数
    width.length - 1 <= level - (showGroup ? 1 : 0) && // 当前层级小于指定列数
    level !== 0;

    var getRow = function getRow(option, level) {
      return h(
        'tr',
        {
          'class': {
            'flex-column': isColumnStack
          }
        },
        [h('td', [_this2.getOption(option, level + (showGroup && isHeader ? 1 : 0))]), option && option.children && h('td', [h(
          'div',
          { key: option.value, style: _extends({}, dropdownMenuColumnStyle) },
          [_this2.getMenuItem(option, level + 1)]
        )])]
      );
    };

    var getGroup = function getGroup(option, level) {
      if (level === deep - 1) {
        return h('tr', [h('td', [h(
          'div',
          { 'class': prefixCls + '-menu', style: _extends({}, dropdownMenuColumnStyle) },
          [_this2.getMenuItem(option, level)]
        )])]);
      }
      return option.children && option.children.length && option.children.map(function (row) {
        return getRow(row, level);
      });
    };

    var columnProps = {
      style: {
        height: columnHeight && level === 0 ? columnHeight + 'px' : null
      }
    };
    var columnScrollProps = {
      style: {
        overflow: 'hidden auto',
        position: 'relative'
      }
    };

    if (level < deep - 1 || isHeader) {
      return h('div', [fastFinderOption.length > 0 && fastFinder !== false && fastFinderPos === 'left' && level === 0 && h(
        'div',
        _mergeJSXProps([{
          'class': prefixCls + '-menu ' + prefixCls + '-' + fastFinder
        }, columnProps, columnScrollProps]),
        [fastFinderOption && !isHeader ? h('ul', [fastFinderOption.map(function (_ref3) {
          var value = _ref3.value,
              label = _ref3.label;
          return h(
            'li',
            {
              attrs: {
                title: label
              },
              'class': { active: value === currentLetter },
              on: {
                'click': function click() {
                  return _this2.handleChange(value);
                }
              }
            },
            [label]
          );
        })]) : '']
      ), h(
        'div',
        _mergeJSXProps([{
          'class': prefixCls + '-menu ' + prefixCls + '-menu-' + level + ' ' + (level === 0 ? prefixCls + '-menu_scroll' : '')
        }, columnProps, level === 0 ? columnScrollProps : {}]),
        [h('table', [treeNodes && treeNodes.map(function (option) {
          if (showGroup && !isHeader && level === 0) {
            return h(
              'tbody',
              {
                attrs: { id: 'scroll-key-' + option.value }
              },
              [h(
                'tr',
                { 'class': prefixCls + '-menu-group' },
                [h(
                  'td',
                  {
                    attrs: { colspan: deep - 1 }
                  },
                  [_this2.getOption(option, level)]
                )]
              ), getGroup(option, level + 1)]
            );
          } else {
            return getRow(option, level);
          }
        })])]
      )]);
    } else {
      return h(
        'ul',
        {
          style: menuColumnStyle[level],
          'class': level !== deep - 1 || leafsPerColumn === 1 ? '' : 'wrap'
        },
        [treeNodes && treeNodes.map(function (option) {
          return h('li', [_this2.getOption(option, level)]);
        })]
      );
    }
  }
};

export default MenuItem;